export default "__VITE_ASSET__BRxcfJ9O__"